import { cva, type VariantProps } from "class-variance-authority";
import { useTranslation } from "react-i18next";

const loadingSpinnerVariants = cva(
  "animate-spin [animation-duration:1.4s] motion-reduce:[animation-duration:3s]",
  {
    variants: {
      size: {
        xs: "size-5",
        sm: "size-6",
        md: "size-8",
        lg: "size-10",
        xl: "size-12",
      },
    },
    defaultVariants: {
      size: "md",
    },
  },
);

export const LoadingSpinner = ({
  size,
}: VariantProps<typeof loadingSpinnerVariants>) => {
  const { t } = useTranslation(["general"]);

  return (
    // biome-ignore lint/a11y/useAriaPropsSupportedByRole: giving this element a role is a separate accessibility change
    <div
      className="flex items-center justify-center"
      aria-label={t("general:loading")}
    >
      <svg
        aria-hidden
        viewBox="0 0 50 50"
        className={loadingSpinnerVariants({ size })}
      >
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
          className="stroke-primary-100"
        />
        <circle
          cx="25"
          cy="25"
          r="20"
          fill="none"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="90 150"
          transform="rotate(-90 25 25)"
          className="stroke-primary-600 animate-spinner-dash motion-reduce:animate-none"
        />
      </svg>
    </div>
  );
};

export default LoadingSpinner;
